import { LINE_TYPES } from "@/data/constants"
import { canvasHelper } from "@/modules/canvas/canvas-helper.js"

export class LogicalConnection {
    canvas
    fromItem
    toItem
    relation

    constructor(canvas, fromTable, relation) {
        this.canvas = canvas
        this.relation = relation || {}
        this.fromItem = fromTable
    }

    draw() {
        let direction = ['right', 'left']
        if (this.fromItem.right <= this.toItem.left) direction = ['right', 'left']
        else if (this.fromItem.left >= this.toItem.right) direction = ['left', 'right']
        else if (this.fromItem.right <= this.toItem.right) direction = ['right', 'right']
        else if (this.fromItem.left >= this.toItem.left) direction = ['left', 'left']

        this.drawConnection(...direction)
    }

    drawConnection(from, to) {
        const fromX = this.fromItem[from]
        const toX = this.toItem[to]
        const fromY = Math.round(this.fromItem.cy)
        const toY = Math.round(this.toItem.cy)
        const ctx = this.canvas.ctx

        ctx.save()
        try {
            const directions = { left: -1, right: 1 }
            const lineType = this.canvas?.settings?.lineType || LINE_TYPES.BEZIER
            const offset = lineType === LINE_TYPES.FLOWCHART ? 30 : (lineType === LINE_TYPES.STRAIGHT ? 20 : 100)
            const endPointSize = 3
            const arrowHeight = 5
            const arrowLength = 8
            const color = this.toItem?.color || this.canvas?.settings?.lineColor || '#bbb'

            ctx.lineWidth = 1
            ctx.fillStyle = color
            ctx.strokeStyle = color

            const cp1x = fromX + offset * directions[from]
            const cp1y = fromY
            const cp2x = toX + offset * directions[to]
            const cp2y = toY

            ctx.beginPath()
            if (!this.relation?.rel_type || ['one_to_one', 'one_to_many'].includes(this.relation.rel_type)) {
                canvasHelper.circle(ctx, fromX, fromY, endPointSize)
                ctx.fill()
            } else {
                ctx.moveTo(fromX + arrowLength * directions[from], fromY)
                ctx.lineTo(fromX, fromY + arrowHeight)
                ctx.lineTo(fromX, fromY - arrowHeight)
                ctx.lineTo(fromX + arrowLength * directions[from], fromY)
                ctx.stroke()
            }
            ctx.closePath()

            ctx.beginPath()
            ctx.moveTo(fromX, fromY)
            ctx.setLineDash([6])
            if (lineType === LINE_TYPES.FLOWCHART) {
                const cpx = Math.max(cp1x, cp2x)
                ctx.lineTo(cpx, cp1y)
                ctx.lineTo(cpx, cp2y)
                ctx.lineTo(toX, toY)
            } else if (lineType === LINE_TYPES.STRAIGHT) {
                ctx.lineTo(cp1x, cp1y)
                ctx.lineTo(cp2x, cp2y)
                ctx.lineTo(toX, toY)
            } else {
                ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, toX, toY)
            }
            ctx.stroke()
            ctx.closePath()

            ctx.beginPath()
            if (!this.relation?.rel_type || ['one_to_one', 'many_to_one'].includes(this.relation.rel_type)) {
                ctx.moveTo(toX, toY)
                ctx.lineTo(toX + arrowLength * directions[to], toY + arrowHeight)
                ctx.lineTo(toX + arrowLength * directions[to], toY - arrowHeight)
                ctx.lineTo(toX, toY)
                ctx.fill()
            } else {
                ctx.moveTo(toX + arrowLength * directions[to], toY)
                ctx.lineTo(toX, toY + arrowHeight)
                ctx.lineTo(toX, toY - arrowHeight)
                ctx.lineTo(toX + arrowLength * directions[to], toY)
                ctx.stroke()
            }
            ctx.closePath()
        } finally {
            ctx.restore()
        }
    }
}
